import styled from 'styled-components';

export const FooterWrapper = styled.footer`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 32px;
    width: 100%;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    gap: 16px;

    button {
        flex: 1;
    }
`;
